import { useState } from "react"

interface ShowMoreTextProps {
  text: string
  row: any
  onSummarize: (row: any) => void
}

export const ShowMoreText: React.FC<ShowMoreTextProps> = ({ text, row, onSummarize }) => {
  const [showMore, setShowMore] = useState(false)

  return (
    <div>
      <div className={`${showMore ? "whitespace-pre-wrap" : "truncate-text"} max-h-80 overflow-scroll wrap-anywhere`}>
        {text}
      </div>
      <div className={"flex-row gap-2 mt-1 flex"}>
        <button className="btn btn-xs btn-outline cursor-pointer" onClick={() => setShowMore(!showMore)}>
          {showMore ? "Меньше" : "Больше"}
        </button>
        <button className="btn btn-xs btn-outline" onClick={() => onSummarize(row)}>
          Суммаризация
        </button>
      </div>
    </div>
  )
}
